import { useEffect, useState } from "react";
import { collection, onSnapshot, query, where } from "firebase/firestore";
import { auth, db } from "../firebase";
import dayjs from "dayjs";

export default function useMonthlyStats() {
  const [stats, setStats] = useState({});

  useEffect(() => {
    const user = auth.currentUser;
    if (!user) return;

    const q = query(collection(db, "receipts"), where("uid", "==", user.uid));

    const unsubscribe = onSnapshot(q, (snapshot) => {
      const data = {};

      snapshot.forEach((doc) => {
        const receipt = doc.data();
        const date = receipt.uploadedAt?.toDate?.();
        if (!date) return;

        const month = dayjs(date).format("YYYY-MM");
        data[month] = data[month] || {
          totalSpent: 0,
          count: 0,
          vendors: {},
          categories: {},
        };

        const amount = parseFloat(receipt.total);
        if (!isNaN(amount)) {
          data[month].totalSpent += amount;
        }

        data[month].count += 1;

        const vendor = receipt.vendor || "Unknown";
        data[month].vendors[vendor] = (data[month].vendors[vendor] || 0) + 1;
        const category = receipt.category || "Uncategorized";
        data[month].categories[category] =
          (data[month].categories[category] || 0) + 1;
      });

      setStats(data);
    });

    return unsubscribe;
  }, []);

  return stats;
}
